export default __webpack_public_path__ + "static/media/roboto-v20-latin-italic.d022bc70.woff2";